export default __webpack_public_path__ + "static/media/sc-lock-up-english-grey-rgb.430d53c9.png";